<template>
  <transition name="myDialog">
    <div v-show="loading" class="spinner">
      <div class="loading"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SysLoading",
  props: {
    loading: {
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>
.spinner {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading {
    height: 80px;
    width: 80px;
    background-image: url('../../assets/sport/loading.gif');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

@media only screen and (max-width: 600px) {
  .spinner .loading {
    height: 50px;
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysLoading.vue